module.exports = "https://cdn-skillquest.mathletics.com/app/168/assets/images/610fd3f05d4c18a3588036373633822b.svg";